"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RasterSortOption = exports.RasterGenerationStrategy = void 0;
var RasterGenerationStrategy;
(function (RasterGenerationStrategy) {
    RasterGenerationStrategy["FLAT_OR_DISCRETE_RANGE"] = "flat_or_discrete_range";
    RasterGenerationStrategy["DISCRETE_RANGE"] = "discrete_range";
    RasterGenerationStrategy["EQUAL_COUNT"] = "equal_count";
    RasterGenerationStrategy["EQUAL_COUNT_BY_SIGN"] = "equal_count_by_sign";
    RasterGenerationStrategy["UNIQUE_VALUE"] = "mapping";
    RasterGenerationStrategy["UNIQUE_VALUE_BY_TIFF_MAPPING"] = "unique_value_by_tiff_mapping";
})(RasterGenerationStrategy = exports.RasterGenerationStrategy || (exports.RasterGenerationStrategy = {}));
/**
 * Sort options for unique value tiff mapping rasters
 * DEFAULT: applies the default sort() method
 * AREA: Sorts by area descending
 */
var RasterSortOption;
(function (RasterSortOption) {
    RasterSortOption["AREA"] = "area";
})(RasterSortOption = exports.RasterSortOption || (exports.RasterSortOption = {}));
